import { Injectable } from '@angular/core';
import { Button } from 'primeng/primeng';

@Injectable()
export class LoadingService {
    constructor() { }
    private taskCount = 0;

    show() {
        if (this.taskCount == 0) {
            this.setLoading(true);
        }
        this.taskCount++;
    }

    hide() {
        this.taskCount--;
        if (this.taskCount < 1) {
            this.setLoading(false);
        }
    }

    private setLoading(enable) {
        let body = $('body');
        if (enable) {
            $(body).addClass('m-page--loading-non-block');
            $("button[type='submit']").attr("disabled", "disabled");
        } else {
            $(body).removeClass('m-page--loading-non-block');
            $("button[type='submit']").removeAttr("disabled");
        }
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/loading.service.ts